import { createSelector } from 'reselect';
import { isNil } from 'lodash';
import { fromJS, Map } from 'immutable';
import { PagesHistoryState } from './reducer';
import { Page, PagesMap } from '../../Models';
import _ from 'lodash';

const selectUserPagesState = (state: any) => {
  return state.pagesHistory;
};

const selectUserPagesHistoryState = (state: any): PagesHistoryState => {
  return state.pagesHistory;
};

export const getPagesHistory = createSelector(
  selectUserPagesHistoryState,
  state => {
    return state.items;
  },
);

export const getPagesHistoryArray = createSelector(
  selectUserPagesHistoryState,
  state => {
    return pagesMapToPagesArray(state.items);
  },
);

export const pagesMapToPagesArray = (pagesMap: PagesMap): Page[] =>
  _.sortBy(_.values(pagesMap), page => Date.parse(page.createdAt));

export const makeGetPagesHistoryExistingPage = (date: string) => {
  return createSelector(
    (state: any) => {
      return state.pagesHistory.items[date];
    },
    (userPage: Page) => {
      const isPageUnavailable = isNil(userPage) || userPage.isDeleted;
      return isPageUnavailable ? null : userPage;
    },
  );
};

export const makeGetPagesHistoryAnyPage = (date: string) => {
  return createSelector(
    getPagesHistory,
    state => {
      return state[date];
    },
  );
};

export const getPagesHistoryLastSyncDate = createSelector(
  selectUserPagesState,
  substate => {
    return substate.lastSyncDate;
  },
);

export const getWordsCountToDays = createSelector(
  getPagesHistory,
  items => {
    return Map(items)
      .filter((value: any) => {
        return !value.isDeleted;
      })
      .flatMap((value: any, key: string) => {
        return fromJS({
          [key]: value.text.split(' ').length,
        });
      })
      .toJS() as any;
  },
);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/selectors.ts